(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['skins.input.RadioGroupDefaultSkin'] = {
  "react": [
    [
      "fieldset",
      null,
      [],
      {},
      [
        "legend",
        "label-legend",
        [],
        {},
        [
          "div",
          "label",
          [],
          {}
        ]
      ],
      [
        "div",
        "items",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "radioButton": {
      "skin": "wysiwyg.common.components.radio.viewer.skins.RadioButtonDefaultSkin"
    }
  },
  "params": {
    "fnt2": "FONT",
    "txt2": "TEXT_COLOR",
    "txtlblrq": "COLOR_ALPHA"
  },
  "paramsDefaults": {
    "fnt2": "font_8",
    "txt2": "color_15",
    "txtlblrq": "transparent"
  },
  "css": {
    "%items": "display:-webkit-box;display:-webkit-flex;display:flex;",
    "%_horizontal-axis %items": "-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;",
    "%_vertical-axis %items": "-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;",
    "%label-legend": "width:100%;",
    "%label": "[fnt2]  color:[txt2];word-break:break-word;display:inline-block;line-height:1;width:100%;",
    "%_required %label::after": "content:\" *\";color:[txtlblrq];"
  }
}

        return skins;
    }));